import ROIPredictionsStore from '@/Core.Service.Domain/Sites/ROIPredictions/Store';
import UtilityCompaniesStore from '@/Core.Service.Domain/Sites/UtilityCompanies/Store';
import SiteSystemsStore from '@/Core.Service.Domain/Sites/SiteSystems/Store/index.ts';

export default {
  namespaced: true,
  modules: {
    ROIPredictionsStore,
    UtilityCompaniesStore,
    SiteSystemsStore,
  },
};
